module.exports = __webpack_public_path__ + "img/1125-joy-thinking.4de42650.png";